import React, {useEffect, useState} from 'react';
import axios from "../../../helpers/axios";
import {Helmet} from "react-helmet";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import {Table} from "reactstrap";
import {SalesRegisterCreateRoute, SalesRegisterListRoute} from "../../routesConstants";
import {Link} from "react-router-dom";
import SearchSelect from "../../../components/searchSelect";

const CounterpartyList = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState()
  const [list, setList]=useState(null)

  useEffect(() => {
    axios.post('/api/salesRegister/')
      .then(({data})=>{
        setData(data.items)
      })
      .finally(()=>{
      setLoading(false)
    })
    axios.post('/api/counterparty/searchInput', )
      .then(({data})=>{
        setList(data.data)
      })
  }, []);
  return (
    <>
      <Helmet>
        <title>Реестры продаж</title>
      </Helmet>
      <Portlet>
        <PortletHeader title={'Список покупателей'} toolbar={<PortletHeaderToolbar>
          {data && <div style={{width: 200, marginLeft: 4}}>
            <SearchSelect
              onChange={v => {
                console.log('v', v)
                window.open(SalesRegisterListRoute + `/${v}`)
              }}
              defaultValue={''}
              label={'Покупатель'}
              array={list}/>
          </div>}
          <Link to={SalesRegisterCreateRoute} className="btn btn-sm btn-primary ml-2">
            <i className="la la-plus"/>
            Добавить
          </Link>
        </PortletHeaderToolbar>}/>
        {data &&
          <PortletBody>
            <Table>
              <thead>
              <tr>
                <td>Клиент</td>
                <td>Регистров</td>
                <td>Период</td>
              </tr>
              </thead>
              <tbody>
              {data.map((row, index) => {
                return <tr key={index}>
                  <td><Link to={SalesRegisterListRoute + `/${row.counterparty.id}`}>{row.counterparty.name}</Link></td>
                  <td>{row.registersCount}</td>
                  <td>{row.period}</td>
                </tr>
              })}
              </tbody>
            </Table>
          </PortletBody>
          }
      </Portlet>
    </>
  );
};

export default CounterpartyList;
